<template>
   
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <h3 v-if="editMemo.id">{{'Vorgabe bearbeiten'}}</h3>
              <h3 v-else>{{'Neue Abwesenheit anlegen'}}</h3>
               
               
              <div v-if="false">
                <!-- DEBUGG -->
                idCompany: {{editMemo.idCompany}}
                idUser: {{editMemo.idUserClient}}
              </div>
              
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <form @keyup.esc="$emit('cancel', memo)" @submit.prevent="onSubmit" :id="_uid">
              <!-- <form @keyup.esc="$emit('cancel', memo)" :id="_uid"> -->
                
             
              
                <label for="xmemo-datetime-begin">Grund:</label>
                <div class="row form-group" >
                  <div class="col-sm-12">
                    <div class="btn-group " data-toggle="buttons">
                      <label v-for="item in reasons" 
                        class="btn btn-default" 
                        :class="{ active: reason == item }"
                        @click="reason = item" 
                        v-text="item">
                      </label>
                    </div>
                    -
                    <i><label class="btn btn-default" @click="reason = ''" :class="{ active: reason == '' }">Kein Grund</label></i>
                  </div>
                </div>
              
                <br>

                <div class="row form-group">
                  
                  <div class="col-sm-6 form-group">
                    <label for="memo-datetime-begin">Beginn/Abwesenheit:</label>
                    <cc-datetime label_id="memo-datetime-begin" v-model="editMemo.datetimeBegin"></cc-datetime>
                  </div>

                  <div class="col-sm-6 form-group">
                    <label for="memo-datetime-end">Zurück/Dienstbeginn:</label>
                    <cc-datetime label_id="memo-datetime-end" v-model="editMemo.datetimeEnd"></cc-datetime>
                  </div>   
                               
                </div>                


              <label for="xmemo-datetime-begin">Dienst:</label>
                <div class="form-group " >
                  <div class="xcol-sm-12">
                    <div class="btn-group btn-group-justified" data-toggle="buttons">
                      <label v-for="item in services" 
                        class="btn btn-default" 
                        :class="{ active: service == item }"
                        @click="service = item" 
                        v-text="item">
                      </label>
                    </div>
                  </div>
                </div>
                
                <br>

               
              
              
              <!-- Vertreter -->
<!---              
              <user-client-typeahead @onHit="onAddAbsence"></user-client-typeahead>
               
                <div class="form-group">
                  <label for="memo-proxy">Vertreter:</label>
                  <div  style="margin-bottom: 15px" v-for="userClient in editMemo.userClientRef" >
                    <span class="tag label label-default">
                      <span>
                        {{userClient.firstName}} {{userClient.lastName}} {{userClient.department}} {{userClient.room}} {{userClient.function}}
                      </span>
                      <a>
                        <i 
                        @click="onRemoveAbsence(userClient)"  
                        class="remove glyphicon glyphicon-remove-sign glyphicon-white" 
                        title="Vertreter entfernen">
                        </i>
                      </a>
                    </span>
                  </div>
                </div>                
-->                
              <!-- END Vertreter -->
               
<!--               
               <div class="form-group">
                  <label for="memo-type">Art :</label>
                  <select required id="memo-type" size="5" class="form-control text-left" v-model="editMemo.typ">
                    <option v-for="option in MemoConf.TYP"
                      v-bind:value="option.OPTION.VALUE"
                      v-text="option.OPTION.TEXT">
                    </option>
                  </select>
                </div>
                                

                <div class="form-group">
                  <label for="memo-headline">Überschrift:</label>
                  <input  v-focus required 
                    type="text" 
                    class="form-control" 
                    id="memo-headline" 
                    placeholder="Überschrift..." 
                    v-model="editMemo.headline">
                </div>
                
                <div class="form-group">
                  <label for="memo-summary">Zusammenfassung:</label>
                  <input type="text" class="form-control" id="memo-summary" placeholder="Zusammenfassung..." v-model="editMemo.summary">
                </div>
-->
                               
                <div class="form-group">
                  <label for="memo-text">Beschreibung:</label>
                  <textarea class="form-control" id="memo-text" rows="6" placeholder="Beschreibung ..."  v-model="editMemo.text"></textarea>
                </div>
<!--
                <div class="form-group">
                  <label for="memo-type">Ansicht der Beschreibung:</label>
                  <select id="memo-view" class="form-control text-right" v-model="editMemo.view">
                    <option v-for="option in MemoView.TYP"
                      v-bind:value="option.OPTION.VALUE"
                      v-text="option.OPTION.TEXT">
                    </option>
                  </select>
                </div>
-->                
                
              </form>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button type="submit"
                :form="_uid"
                class="btn btn-primary">
                Speichern
              </button>

              <button type="" 
                class="btn btn-default"
                @click="$emit('cancel', memo)">
                Abbrechen
              </button>

              <button type="" 
                v-if="editMemo.id" 
                class="btn btn-danger"   
                @click="$emit('remove', memo)">
                Löschen
              </button>               
               
            </slot>
          </div>
          
        </div>
      </div>
    </div>
  </transition>

</template>



<script>

import MemoCommon from './common/memo.common'
import DateTime from './helper/datetime.vue'
import UserClientTypeahead from './UserClientTypeahead.vue'


export default {
  
  extends: MemoCommon,
  
  components: {
    'cc-datetime': DateTime,
    'user-client-typeahead': UserClientTypeahead,

  },  

  
  data () {
    return {
      editMemo: JSON.parse(JSON.stringify(this.memo)),
      reason: "",
      reasons: ["Meeting", "Mittag", "geschäftlich unterwegs","Urlaub", "Messe", "Krank"],
      service: "",
      services: ["Vorzimmer auf Handy", "Auftragsdienst"],
    }
  },
  
  created: function () {
  },
  
  computed: {
  },  
  
  
  methods: {

    onAddAbsence: function (item) {
      this.editMemo.userClientRef.push(item);
    },

    onRemoveAbsence: function (item) {
      this.editMemo.userClientRef.splice(this.editMemo.userClientRef.indexOf(item.id), 1);
      console.log('onRemoveAbsence'+ item.id);
    },


    onSubmit: function () {
      if(_.isEqual(this.memo, this.editMemo)){
        // keine Änderung, speichern nicht notwendig
        this.$emit('cancel', this.memo)
      }else{
        // speichern
        this.editMemo.typ = 0;
        this.editMemo.text = this.reason + '\n' + this.editMemo.text;
        this.editMemo.summary = this.service;
        this.editMemo.headline = "Abwesenheit";
        
        this.$emit('save', this.editMemo)
      }
    },
    
  },
}
  
</script>



<style scoped>
  
.tag {
  font-size: 14px;
  padding: .3em .4em .4em;
  margin: 0 .1em;
}
.tag a {
  color: #bbb;
  cursor: pointer;
  opacity: 0.6;
}
.tag a:hover {
  opacity: 1.0
}
.tag .remove {
  vertical-align: bottom;
  top: 0;
}
.tag a {
  margin: 0 0 0 .3em;
}
.tag a .glyphicon-white {
  color: #fff;
  margin-bottom: 2px;
} 
  .label-default{
    background-color: #bbb;    
  }  
  
 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80vh;
  /*margin: 0px auto;*/
  margin-left: 15%;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  overflow: scroll;
  height:50vh;
  margin: 20px 0;
  padding-bottom: 50px;
}

.modal-footer {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid lightgray;
  text-align: right;
}

  .modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

  
input:invalid {
  border: 1px solid red;
}  
</style>



// WEBPACK FOOTER //
// MemoAbsenceModal.vue?8cac1ef8